import { BaseCardProps, Card } from '@bcp-nextgen-dx-component-factory/design-system';

/**
 *
 *
 * @return {*}  {JSX.Element}
 */
export const CardBaseAb: React.FC<BaseCardProps> = (props: BaseCardProps): JSX.Element => {
	return (
		<Card.Base
			transition={''}
			borderWidth={0}
			flexDirection={'column'}
			height={'auto'}
			width={'100%'}
			margin={0}
			maxHeight={'none'}
			maxWidth={'none'}
			minHeight={'none'}
			minWidth={'none'}
			position={'initial'}
			zIndex={9}
			appearance={'primary'}
			radius={'large'}
			{...props}
		/>
	);
};
